


























import {Vue, Component, Prop} from 'vue-property-decorator';
import SingleCartableOwnerMobile from '@/components/MobileComponents/CartableOwnerMobile/SingleCartableOwnerMobile.vue';
import { getPersianDate } from '@/util/utils';
import { getBranches } from '@/store/api';
import * as letterService from '@/store/Services/letterServices';
import ThemeSelector from '@/components/UiComponents/ThemeSelector.vue';

@Component({
    components: {SingleCartableOwnerMobile, ThemeSelector}
})
export default class CartableTitleMobile extends Vue{
    clock = 0;
    currentTime = '';
    currentDate = '';
    branch = '';
    async created(){
        const serverTime = new Date(await letterService.getServerTime());
        
        this.clock = setInterval(()=>{
            const d =  serverTime;//new Date();
            this.currentTime = d.toLocaleTimeString();
            this.currentDate = getPersianDate((new Date()).toString(),"YYYY/MM/DD",false);
            d.setSeconds(d.getSeconds() + 1);
        }, 1000);
        const branches =  await getBranches();
        this.branch = branches[0].name;
    }

    onLetterOwnerSet(e: boolean){
        this.$emit('on-letter-owner-set',e);
    }
}
